import 'fslightbox';

export function Gallery() {
    const gallery = document.querySelector('[data-component="Gallery"]');

    if (!gallery) return;

    const lightbox = new FsLightbox();
    const images = gallery.querySelectorAll('a[data-fslightbox]');
    lightbox.props.sources = Array.from(images).map((link) => link.href);

    console.log(images)
    images.forEach((image, index) => {
        image.addEventListener('click', (event) => {
            event.preventDefault();
            lightbox.open(index);
        });
    })
}